import {
    Image, FileText, Play, Music, File
} from 'lucide-react';

export const showWidgetContainer = false;
export interface ViolationType {
  id: number;
  value: string;
  label: string;
  tagStyle?: string;
};

export interface ViolationStatus {
  id: number;
  value: string;
  label: string;
  tagStyle?: string;
  nextStep?: string[];
};

export const violationTypes: ViolationType[] = [
  { id: 1, value: "copyright_infringement", label: "codeCopyrightInfringement", tagStyle: "bg-green-100" },
  { id: 2, value: "trademark_violation", label: "codeTrademarkViolation", tagStyle: "bg-yellow-300" },
  { id: 3, value: "unauthorized_usage", label: "codeUnauthorizedUsage", tagStyle: "bg-blue-100" },
  { id: 4, value: "plagiarism", label: "codePlagiarism", tagStyle: "bg-gray-500 text-white" },
  { id: 5, value: "deep_fake", label: "codeDeepfake", tagStyle: "bg-fuchsia-100" },     
  { id: 6, value: "content_theft", label: "codeContentTheft", tagStyle: "bg-emerald-100" },
  { id: 7, value: "license_violation", label: "codeLicenseViolation", tagStyle: "bg-blue-300" },
  { id: 8, value: "impersonation", label: "codeImpersonation", tagStyle: "bg-indigo-200"},
  { id: 9, value: "contract_violation", label: "codeContractViolation", tagStyle: "bg-lime-200"},
  { id: 10, value: "other", label: "codeOther", tagStyle: "bg-cyan-100"},
];

export const violationStatuses = [
  { 
    id: 1,
    value: "detected",
    label: "codeDetected",
    tagStyle: "bg-yellow-100 text-yellow-700 border-yellow-300",
    nextStep: ["verified", "dismissed"]
  }, // "đã phát hiện",
  { id: 2,
    value: "verified",
    label: "codeVerified",
    tagStyle: "bg-blue-100 text-blue-700 border-blue-300",
    nextStep: ["notified", "content_removed", "content_modified"]
  }, // "đã xác minh",
  {
    id: 3,
    value: "notified",
    label: "codeNotified",
    tagStyle: "bg-green-100 text-green-700 border-green-300",
    nextStep: ["content_removed", "content_modified", "dispute_filed", "resolved"]
  }, // "đã thông báo",
  { 
    id: 4,
    value: "acknowledged",
    label: "codeAcknowledged",
    tagStyle: "bg-red-100 text-red-700 border-red-300",
    nextStep: ["content_removed", "content_modified", "resolved"]
  }, // "đã xác nhận",
  { 
    id: 5,
    value: "content_removed",
    label: "codeContentRemoved",
    tagStyle: "bg-green-100 text-green-700 border-green-300"
  }, // "nội dung đã xóa",
  { 
    id: 6,
    value: "content_modified",
    label: "codeContentModified",
    tagStyle: "bg-green-100 text-green-700 border-green-300"
  }, // "nội dung đã sửa đổi",
  { id: 7,
    value: "dispute_filed",
    label: "codeDisputeFiled",
    tagStyle: "bg-red-100 text-red-700 border-red-300",
    nextStep: ["legal_action"]
  }, // "tranh chấp đã nộp",
  { 
    id: 8,
    value: "under_review",
    label: "codeUnderReview",
    tagStyle: "bg-orange-100 text-orange-700 border-orange-300",
  }, // "đang xem xét",
  { 
    id: 9,
    value: "resolved",
    label: "codeResolved",
    tagStyle: "bg-green-100 text-green-700 border-green-300",
  }, // "đã giải quyết",
  { 
    id: 10,
    value: "dismissed",
    label: "codeDismissed",
    tagStyle: "bg-red-100 text-red-700 border-red-300"
  }, // "đã bác bỏ",
  { 
    id: 11,
    value: "legal_action",
    label: "codeLegalAction",
    tagStyle: "bg-red-100 text-red-700 border-red-300",
  }, // "hành động pháp lý",
  {
    id: 12,
    value: "escalated",
    label: "codeEscalated",
    tagStyle: "bg-red-200 text-red-800 border-red-400",
  }, // "đã báo cáo",
  { 
    id: 13,
    value: "expired",
    label: "codeExpired",
    tagStyle: "bg-gray-100 text-gray-700 border-gray-300"
  }, // "đã hết hạn"
];

export const violationSeverities = [
  { id: 1, value: "low", label: "codeLow" },
  { id: 2, value: "medium", label: "codeMedium" },
  { id: 3, value: "high", label: "codeHigh" },
];

export const contentKinds = [
  { value: 'audio', code: 'audio' },
  { value: 'video', code: 'video' },
  { value: 'image', code: 'image' },
  { value: 'text', code: 'text' },
  { value: 'other', code: 'other' },
];

export const contentStatuses = [
  { value: 'approved', code: 'approved' },
  { value: 'pending', code: 'pending' },
  { value: 'rejected', code: 'rejected' },
  { value: 'draft', code: 'draft' },
];

// Content type options for filter
export const contentTypes = [
    // { value: 'all', label: t('works:contentTypes.all', 'Tất cả') },
    { value: 'image', label: 'works:contentTypes.image', icon: Image, color: 'text-blue-800', background: 'bg-blue-500' },
    { value: 'video', label: 'works:contentTypes.video', icon: Play, color: 'text-green-800', background: 'bg-green-500' },
    { value: 'audio', label: 'works:contentTypes.audio', icon: Music, color: 'text-yellow-800', background: 'bg-yellow-500' },
    { value: 'text', label: 'works:contentTypes.text', icon: FileText, color: 'text-cyan-800', background: 'bg-cyan-500' },
    { value: 'other', label: 'works:contentTypes.other', icon: File, color: 'text-gray-800', background: 'bg-gray-500' },
];
export const enumViolationType = (value: string) => 
  violationTypes.find((type) => type.value === value) || violationTypes[0];

export const enumViolationStatus = (value: string) => 
  violationStatuses.find((status) => status.value === value) || violationStatuses[0];

export const enumViolationSeverity = (value: string) => 
  violationSeverities.find((status) => status.value === value) || violationSeverities[0];

